import { render, staticRenderFns } from "./IconPig.vue?vue&type=template&id=49a12303&"
import script from "./IconPig.vue?vue&type=script&lang=ts&"
export * from "./IconPig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports